import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNotificationStore = defineStore('notification', () => {
  const notifications = ref([])
  
  const addNotification = (message, type = 'info', duration = 3000) => {
    const id = Date.now()
    const notification = {
      id,
      message,
      type,
      show: false
    }
    
    notifications.value.push(notification)
    
    // 显示动画
    setTimeout(() => {
      const notif = notifications.value.find(n => n.id === id)
      if (notif) notif.show = true
    }, 100)
    
    // 自动隐藏
    setTimeout(() => {
      removeNotification(id)
    }, duration)
    
    return id
  }
  
  const removeNotification = (id) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      const notification = notifications.value[index]
      notification.show = false
      
      // 等待动画完成后移除
      setTimeout(() => {
        const currentIndex = notifications.value.findIndex(n => n.id === id)
        if (currentIndex > -1) {
          notifications.value.splice(currentIndex, 1)
        }
      }, 300)
    }
  }
  
  const showSuccess = (message) => addNotification(message, 'success')
  const showError = (message) => addNotification(message, 'error')
  const showInfo = (message) => addNotification(message, 'info')
  
  return {
    notifications,
    addNotification,
    removeNotification,
    showSuccess,
    showError,
    showInfo
  }
})